/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowDownLeft = createReactComponent("arrow-down-left", "IconArrowDownLeft", [
  ["path", { d: "M17 7l-10 10", key: "svg-0" }],
  ["path", { d: "M16 17l-9 0l0 -9", key: "svg-1" }]
]);

export { IconArrowDownLeft as default };
//# sourceMappingURL=IconArrowDownLeft.js.map
